import React from 'react';
import { Container } from 'react-bootstrap';
import SprintSectionHeader from './sprint-section-header';

export default function SprintFeatureGrid({ 
    sectionId, 
    label, 
    titlePrefix, 
    highlightText, 
    titleSuffix, 
    subtitle, 
    items, 
    gridClass = '' 
}) {
    return (
        <section className="sprint-included" id={sectionId}>
            <Container>
                <SprintSectionHeader 
                    label={label}
                    titlePrefix={titlePrefix}
                    highlightText={highlightText}
                    titleSuffix={titleSuffix}
                    subtitle={subtitle}
                    center={true}
                />
                
                <div className={`sprint-included-grid ${gridClass}`}>
                    {items && items.map((item, idx) => (
                        <div className={`sprint-included-card sprint-reveal sprint-delay-${(idx % 6) + 1}`} key={idx}>
                            <div className="card-icon">{item.icon}</div>
                            <h4>{item.title}</h4>
                            <p>{item.desc}</p>
                        </div>
                    ))}
                </div>
            </Container>
        </section>
    );
}
